<template>
  <section class="gm" ref="gm">
    <div class="map_wrapper" ref="wrapper">
      <div class="map" ref="map">
        <the-loader :isAbsolute="true"></the-loader>
      </div>
    </div>
    <div class="popup" v-show="showPopup">
      <div class="popup_content" v-html="popupContent"></div>
    </div>
  </section>
</template>

<script>
/* global google */
import TheLoader from './reservation/TheLoader.vue'
import { Loader } from '@googlemaps/js-api-loader'
import { MarkerClusterer } from '@googlemaps/markerclusterer'
import { gmStyle2 } from '@/assets/google.maps.style.js'

export default {
  props: {
    points: String,
  },
  data() {
    return {
      initMapPosition: {
        lat: 47.8095954,
        lng: 8.032245,
      },
      openedInfoView: null,
      map: null,
      markers: [],
      mapIcon: null,
      showPopup: false,
      popupContent: '',
      openedPointId: null,
    }
  },
  computed: {
    mapPins() {
      const points = JSON.parse(this.points)
      return !points.length
        ? []
        : points
            .filter((v) => v.pickup !== '' && v.pickup !== false)
            .map((v) => {
              return {
                id: v.id,
                lat: v.coordinates.lat,
                lng: v.coordinates.lng,
                name: v.name,
                type: v.storage,
                openHours: v.openHours,
                brand: v.brand,
                location: v.location,
                content: 'Popup Content',
                available: true,
              }
            })
    },
  },
  components: {
    TheLoader,
  },
  async mounted() {
    this.loadGoogleMaps()
  },
  methods: {
    loadGoogleMaps() {
      const loader = new Loader({
        apiKey: window.gm_object.key,
        version: 'weekly',
        libraries: ['places'],
      })

      loader.load().then(this.initGoogleMaps)
    },
    initGoogleMaps() {
      this.setMapIcons()
      const zoom = 10

      this.map = new google.maps.Map(this.$refs.map, {
        center: this.initMapPosition,
        zoom,
        styles: gmStyle2,
        mapTypeControl: false,
        zoomControl: true,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
      })

      this.infoWindow = new google.maps.InfoWindow({
        content: '',
        disableAutoPan: true,
        shouldFocus: true,
      })

      this.setMarkers()
    },
    setMapIcons() {
      this.mapIcon = {
        path: 'M15,0 C23.2842712,0 30,6.74747126 30,15.0708989 C30,17.943914 29.1998626,20.6291638 27.8112665,22.9139689 C26.2053387,25.556373 22.4970764,31.4367438 16.6864794,40.5550815 L16.6864794,40.5550815 C16.5321396,40.8023095 16.3237137,41.010902 16.0780521,41.1677002 C15.1469737,41.7619786 13.9104277,41.4889483 13.3161493,40.55787 L13.3161493,40.55787 L12.9969925,40.0545369 C7.38168097,31.2307356 3.7848623,25.5269525 2.20653653,22.9431874 C0.806978577,20.6520704 0,17.9561701 0,15.0708989 C0,6.74747126 6.71572875,0 15,0 Z M15,8.4 C11.3549207,8.4 8.4,11.3549207 8.4,15 C8.4,18.6450793 11.3549207,21.6 15,21.6 C18.6450793,21.6 21.6,18.6450793 21.6,15 C21.6,11.3549207 18.6450793,8.4 15,8.4 Z',
        fillColor: '#000',
        fillOpacity: 1,
        strokeWeight: 0,
        rotation: 0,
        scale: 1,
        anchor: new google.maps.Point(15, 42),
      }

      this.mapIconActive = { ...this.mapIcon, fillColor: '#df3d3d' }
    },
    setMarkers() {
      if (!this.mapPins) return true

      var latlngbounds = new google.maps.LatLngBounds()

      this.markers = this.mapPins
        .filter((v) => v.available)
        .map((point) => {
          const position = {
            lat: point.lat,
            lng: point.lng,
          }
          const name = point.name
          const icon = point.id === this.deliverPlaceID ? this.mapIconActive : this.mapIcon

          const marker = new google.maps.Marker({
            position,
            icon,
            name,
            animation: google.maps.Animation.DROP,
          })

          marker.id = point.id
          marker.settings = point

          if (point.available) {
            marker.addListener('click', () => this.openInfoView(marker))
          }

          latlngbounds.extend(position)

          return marker
        })

      const renderer = {
        render: ({ count, position }) => {
          const svg = window.btoa(`<svg fill="#DE2C1D" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
						<circle cx="120" cy="120" opacity="1" r="110" />
					</svg>`)
          return new google.maps.Marker({
            // label: { text: String(count), color: 'white', fontSize: '10px' },
            // position,
            // // adjust zIndex to be above other markers
            // zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
            position,
            icon: {
              url: `data:image/svg+xml;base64,${svg}`,
              scaledSize: new google.maps.Size(45, 45),
            },
            label: {
              text: String(count),
              color: 'rgba(255,255,255,0.9)',
              fontSize: '14px',
              FontFace: 'tt_firs_neue_demibold',
            },
            // adjust zIndex to be above other markers
            zIndex: 1000 + count,
          })
        },
      }

      new MarkerClusterer({ markers: this.markers, map: this.map, renderer })

      this.map.fitBounds(latlngbounds, 20)
    },
    openInfoView(marker) {
      const pointData = marker.settings
      this.openedPointId = pointData.id

      const hours = pointData?.openHours.reduce((acc, cur) => {
        acc += `<span class="hours_row"><span class="hours_label">${this.$t(cur.day)}</span><span>${
          cur.time
        }</span></span>`
        return acc
      }, '')

      let content = `
      			<p><span class="title">${pointData.brand}</span><br/>${pointData.location}</p>
      			<p class="hours_block">${hours}</p>`

      if (window.innerWidth >= 768) {
        this.showPopup = false
        this.infoWindow.setContent(content)
        this.infoWindow.open({
          map: this.map,
          anchor: marker,
        })
        this.map.panTo(this.infoWindow.getPosition())
        this.map.panBy(0, -150)
      } else {
        this.openPopup(content)
      }
    },
    openPopup(content) {
      this.showPopup = true
      this.popupContent = content
    },
    clearSelection() {
      this.showPopup = false
    },
    clearMarkers() {
      this.markers.map((v) => {
        v.setMap(null)
      })
      this.markers = []
    },
  },
}
</script>

<style lang="scss" scoped>
.gm {
  position: relative;
  width: 100%;
}

.map {
  width: 100%;
  height: 50vh;
  position: relative;

  .wrapper.is_absolute {
    z-index: 4;

    &::v-deep .loader {
      margin-top: 0;
    }
  }
}

.map_wrapper {
  position: relative;
}

.popup {
  @include fontStyleCopyRegular;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: $colorWhite;
  padding: 20px;
  z-index: 14;

  @include mq($from: tablet) {
    display: none;
  }

  .buttons {
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button {
      margin-left: 20px;
      margin-top: 35px;
    }
  }

  &_content {
    display: flex;
    justify-content: space-between;
    position: relative;

    &:after {
      position: absolute;

      content: '';
      display: block;
      width: 100%;
      left: 0px;
      top: -20px;
      height: 2px;
      background: $colorRed;
    }
  }

  &::v-deep .title {
    font-family: $fontFirsNeueDemiBold;
  }

  &::v-deep .hours_block {
    margin-top: 5px;
    font-size: 12px;
    min-width: 210px;
  }

  &::v-deep .hours_label {
    display: inline-block;
    min-width: 80px;
  }

  &::v-deep .hours_row {
    display: flex;
  }
}
</style>

<style lang="scss">
.gm-style {
  @include fontStyleCopyRegular;

  button {
    @include button();
    margin-top: 20px;
  }

  .gm-style-iw-c {
    border-radius: 5px;
    box-shadow: none;
    padding: 20px 25px;
  }

  .gm-style-iw {
    @include fontStyleCopyRegular;

    .title {
      font-family: $fontFirsNeueDemiBold;
    }

    &-t {
      &::after {
        display: none;
      }
    }

    &-d {
      padding: 0 20px 25px 0;
      min-width: 240px;
    }
  }

  .title {
    font-family: $fontFirsNeueDemiBold;
  }

  .hours_block {
    margin-top: 5px;
    font-size: 12px;
  }

  .hours_label {
    display: inline-block;
    min-width: 80px;
  }

  .hours_row {
    display: flex;
  }
}
</style>
